import styled, { css } from "styled-components";
import ArrowLeft from 'assets/iconsOld/arrow_left.svg';
import ArrowRight from 'assets/iconsOld/arrow_right.svg';

const Arrow = css`
  border: none;
  background-color: ${props => props.theme.old.colors.gray[200]};
  position: absolute;
  top: 43%;
  border-radius: 100%;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  transition: ${({ theme })=> theme.old.transition.default};
  margin: 0;

  &::after {
    content: '';
    position: absolute;
    height: 12px;
    width: 7px;
    background-repeat: no-repeat;
    top: 50%;
    transform: translateY(-50%);
  }

  :hover {
    background-color: ${props => props.theme.old.colors.gray[300]};
  }
`;

export const ArrowBack = styled.div`
  ${Arrow}
  left: 32px;
  right: auto;

  &::after {
    background-image: url(${ArrowLeft});
  }
`;

export const ArrowNext = styled.div`
  ${Arrow}
  left: auto;
  right: 32px;

  &::after {
    background-image: url(${ArrowRight});
  }
`;
